import { useEffect } from 'react'
import type { QueryObserverOptions, UseQueryResult, QueryKey } from '@tanstack/react-query'
import { useGetProfile } from '@/sdk-client/gen/hooks/usersHooks/useGetProfile'
import type {
  GetProfileQueryResponse,
  GetProfile400,
  GetProfile401
} from '@/sdk-client/gen/models/usersModels/GetProfile'
import { setUserProfile } from '../profileStorage'

type UseGetAndCacheProfileOptions = {
  query?: Partial<
    QueryObserverOptions<GetProfileQueryResponse, GetProfile400 | GetProfile401, any, GetProfileQueryResponse, QueryKey>
  >
  client?: Record<string, any>
}

/**
 * Hook that fetches the user profile and automatically saves it to local storage.
 */
export const useGetAndCacheProfile = (options?: UseGetAndCacheProfileOptions) => {
  const profileQuery = useGetProfile(options as any)

  // When the profile is fetched, automatically save it
  useEffect(() => {
    if (profileQuery.data?.result) {
      setUserProfile(profileQuery.data.result)
    }
  }, [profileQuery.data?.result])

  return profileQuery
}
